import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { paths } from '@platform/paths';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private router = inject(Router);
  private location = inject(Location);
  private history: string[] = [];

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.history.push(event.urlAfterRedirects);
    });
  }

  back(): void {
    this.history.pop();
    if (!this.history.length || this.history.at(-1)?.includes(paths.AUTH)) {
      this.clearHistory();
      void this.router.navigateByUrl('/');
    } else {
      this.location.back();
    }
  }

  navigate(path, queryParams?): void {
    void this.router.navigate(path, { queryParams });
  }

  clearHistory(): void {
    this.history = [];
  }
}
